import { Injectable } from '@angular/core';
import { HttpRequestUtils } from './util/http-request-utils';
/**
 * Encapsulates generic configuration, such as the dev mode, etc.
 * @author jsanca
 */
var Config = (function () {
    function Config() {
        this.httpRequestUtils = new HttpRequestUtils();
    }
    return Config;
}()); // E:O:F:Config
export { Config };
Config.decorators = [
    { type: Injectable },
];
/** @nocollapse */
Config.ctorParameters = function () { return []; };
//# sourceMappingURL=config.service.js.map